import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { getSliders } from "../Service/Api"; 
import OnlineRegistration from "./OnlineRegistration";


const DEFAULT_IMAGE =
  "https://webapi.entab.info/api/image/AFGJI/public/Images/slide-0.jpg";
  

const API_URL = "https://webapi.entab.info"

function HomeSlider() {
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const data = await getSliders();

        const visibleSliders = Array.isArray(data)
          ? data
              .filter((item) => item.visibility === false)
              .sort((a, b) => a.position - b.position)
          : [];

        setSliders(visibleSliders);
      } catch (error) {
        console.error("Error loading sliders:", error);
        setSliders([]);
      }
    };

    fetchSliders();
  }, []);

  return (
    <div className="col-sm-12 col-md-9 no-pad slidernotify">
      <div id="myCarousel" className="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          <Carousel>
            {sliders.length === 0 ? (
              <Carousel.Item>
                <img
                  src={DEFAULT_IMAGE}
                  alt="AFGJI"
                  width="100%"
                  className="slider"
                />
              </Carousel.Item>
            ) : (
              sliders.map((slider, index) => (
                <Carousel.Item key={slider._id || index}>
                  <img
                    src={`${API_URL}/api/image/${slider.attachment}`}
                    alt={slider.title || "AFGJI"}
                    width="100%"
                    className="slider"
                  />
                </Carousel.Item>
              ))
            )}
          </Carousel>
        </div>
      </div>
      <OnlineRegistration></OnlineRegistration>
    </div>
  );
}

export default HomeSlider;
